import TeamEdit from './TeamEdit.vue';
export default TeamEdit;
